import { NewbuildingCarousel, TDirection, TOnSlideChangeParams } from '@cian/frontend-newbuilding-carousel-component';

import * as React from 'react';

import { Slide } from './components/Slide';
import { firstPaintOptions, mediaSettings } from './config';
import { ArrowControls } from './components/ArrowControls';

import * as styles from './PromoSlider.css';

interface IPromoSliderProps {
  banners: {
    /** Рекламный дисклеймер **/
    disclaimer?: string | null;
    /** Идентификатор баннера в БД **/
    id: number;
    /** Изображение баннера **/
    image: { url: string };
    /** Подзаголовок **/
    subtitle: string;
    /** Надпись на баннере **/
    text?: string | null;
    /** Надпись на кнопке баннера **/
    textButton: string;
    /** Заголовок **/
    title: string;
    /** URL перехода с баннера **/
    urlLink: string;
  }[];
  testId?: string;
}

interface IPromoSliderState {
  currentSlide: number;
  isShown: boolean;
}

export class PromoSlider extends React.Component<IPromoSliderProps, IPromoSliderState> {
  private intervalId: ReturnType<typeof setInterval>;

  public constructor(props: IPromoSliderProps) {
    super(props);

    this.state = {
      currentSlide: 1,
      isShown: false,
    };
  }

  public componentDidMount() {
    this.setSlidesInterval();
  }

  public componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  private autoSlidesChange = () => {
    if (this.state.isShown) {
      return;
    }

    const { currentSlide } = this.state;
    const { banners } = this.props;

    const nextSlide = banners.length === currentSlide ? 1 : currentSlide + 1;

    this.setState({ currentSlide: nextSlide });
  };

  private setIsShown = (value: boolean) => () => {
    this.setState({ isShown: value });
  };

  private setSlidesInterval = () => {
    this.intervalId = setInterval(this.autoSlidesChange, 10_000);
  };

  private handleSlideChange = ({ currentSlide }: TOnSlideChangeParams) => {
    clearInterval(this.intervalId);
    this.setState(
      {
        currentSlide,
      },
      () => {
        this.setSlidesInterval();
      },
    );
  };

  private handleArrowsClick = (direction: TDirection) => {
    this.setState({
      currentSlide: this.state.currentSlide + direction * 1,
    });
  };

  public render() {
    const { testId, banners } = this.props;
    const { currentSlide } = this.state;

    return (
      <section
        className={styles['carousel']}
        data-testid={testId}
        onMouseEnter={this.setIsShown(true)}
        onMouseLeave={this.setIsShown(false)}
      >
        <NewbuildingCarousel
          media={mediaSettings}
          firstPaintOptions={firstPaintOptions}
          slides={banners.map((banner, index) => (
            <Slide
              key={banner.id}
              active={currentSlide === index + 1}
              disclaimer={banner.disclaimer}
              imageUrl={banner.image.url}
              title={banner.title}
              subtitle={banner.subtitle}
              urlLink={banner.urlLink}
              textButton={banner.textButton}
              sliderControlsView={
                banners.length > 1 && (
                  <ArrowControls
                    disableLeft={currentSlide === 1}
                    disableRight={currentSlide === banners.length}
                    clickHandler={this.handleArrowsClick}
                  />
                )
              }
            />
          ))}
          defaultCurrentSlide={currentSlide}
          onSlideChange={this.handleSlideChange}
        />
      </section>
    );
  }
}
